import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    RateCardStatus,
} from 'app/enums/label.enums'
import {
    ARateCardFormFields,
} from './ARateCardForm.types'

type Params = {
    getAllowedValues: (param: Record<string, string>) => Record<string, string>,
    isEditDisabled: boolean,
    exists: boolean,
    isValidFromEditable: boolean,
}

const aRateCardFormFields = ({
    getAllowedValues,
    isEditDisabled,
    exists,
    isValidFromEditable,
}: Params): DTOCardFormField<ARateCardFormFields>[] => {
    return [{
        title: 'Rate Card',
        classNames: ({
            rateCard,
        }) => {
            return {
                gridCardWrapper: rateCard,
            }
        },
        fields: [
            {
                name: 'status',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(RateCardStatus),
                disabled: true,
                labelKey: 'STATUS',
                hidden: !exists,
            },
            {
                name: 'account',
                componentName: 'AccountSelector',
                labelKey: 'ACCOUNT',
                required: true,
                disabled: isEditDisabled,
            },
            {
                name: 'validFrom',
                componentName: 'DateSelect',
                labelKey: 'VALID_FROM',
                required: true,
                disabled: !isValidFromEditable,
                disablePast: true,
            },
            {
                name: 'validTo',
                componentName: 'DateSelect',
                labelKey: 'VALID_TO',
                disabled: true,
                hidden: !isEditDisabled,
            },
            {
                name: 'copyFrom',
                componentName: 'ARateCardSelector',
                required: true,
                labelKey: 'COPY_RATES_FROM',
                hidden: exists,
            },
            {
                name: 'comment',
                componentName: 'LongText',
                labelKey: 'COMMENT',
                disabled: isEditDisabled,
            },
        ],
    }]
}

export default aRateCardFormFields
